module.exports = {"last_update":1585663558273,"logo_path":"/static/logo.jpg","title_web":"​POS MIS","base_api":"https://rice-api.maeriminterfood.com/"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = 1040
// module chunks = 55